var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      !_setup.isMobile
        ? _c(_setup.InfoLayout, {
            attrs: {
              "current-path": _setup.reverseFull({ name: "contacts" }),
              "is-policy": false,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.t("Контакты", _setup.options)) +
                          "\n    "
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        _setup.isMobile
                          ? _setup.ContactsContentMobile
                          : _setup.ContactsContentDesktop,
                        {
                          tag: "component",
                          attrs: { "data-qa": "service_list_content_list" },
                        }
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2387509317
            ),
          })
        : _c(
            _setup.isMobile
              ? _setup.ContactsContentMobile
              : _setup.ContactsContentDesktop,
            {
              tag: "component",
              attrs: { "data-qa": "service_list_content_list" },
            }
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }